<template>
  <transition appear name="fade">
    <div id="shutdown" class="dialog" @click.self="handleClose">
      <div class="d-flex">
        <cus-button text="重新啟動" color="green" :width="50" style="height: 60px" @click="handleReboot"></cus-button>
        <cus-button text="關閉系統" color="red" :width="50" style="height: 60px" @click="handleShutdown"></cus-button>
      </div>
    </div>
  </transition>
</template>

<script>
import { getCurrentInstance } from 'vue';
import { useActions } from '@/utils/mapStore';

export default {
  name: 'shutdown',
  setup() {
    const { proxy } = getCurrentInstance();

    // 重新啟動
    const doReboot = useActions('system', ['doReboot']);
    const handleReboot = async () => {
      proxy
        .$confirm({
          content: '是否確定要重新啟動？',
          confirmText: '重新啟動',
          confirm2Text: '取消',
          moreConfirm: true,
        })
        .then(async (val) => {
          if (val === '重新啟動') {
            await doReboot();
            proxy.$emit('close');
            proxy.$message('提醒', '重啟中，請稍等 2-3 分鐘後重新整理畫面').catch((e) => e);
          }
        })
        .catch((e) => e);
    };

    // 關閉系統
    const doShutdown = useActions('system', ['doShutdown']);
    const handleShutdown = () => {
      proxy
        .$confirm({
          content: '是否確定要關閉系統？',
          confirmText: '關閉系統',
          confirm2Text: '取消',
          moreConfirm: true,
        })
        .then(async (val) => {
          if (val === '關閉系統') {
            await doShutdown();
            proxy.$emit('close');
            proxy.$message('提醒', '已關機，如需開機請重新連接傳輸盒電源線').catch((e) => e);
          }
        })
        .catch((e) => e);
    };

    // 關閉視窗
    const handleClose = () => {
      proxy.$emit('close');
    };

    return {
      handleReboot,
      handleShutdown,
      handleClose,
    };
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  @include flex-center-center;
  width: 100%;
  height: 100%;
  background-color: $color-mask;
  position: fixed;
  top: 0;
  z-index: 900;
}
.d-flex {
  width: 80%;
  max-width: 390px;
}
</style>
